import {
    AssetServiceLogCreateRequestCalibrationKind,
    AssetServiceLogCreateRequestEventType
} from 'generatedTypes/asset/models';

export const CALIBRATION_EVENT_TYPE = AssetServiceLogCreateRequestEventType.CALIBRATED;

export const PART_REQUIRED_EVENT_TYPES: AssetServiceLogCreateRequestEventType[] = [
    AssetServiceLogCreateRequestEventType.REPLACED,
    AssetServiceLogCreateRequestEventType.SERVICED
];

export const CALIBRATION_UNIT_PART_TYPES: Partial<
    Record<AssetServiceLogCreateRequestCalibrationKind, string>
> = {
    [AssetServiceLogCreateRequestCalibrationKind.FLOW]: 'FLOW_METER',
    [AssetServiceLogCreateRequestCalibrationKind.PUMP]: 'PUMP'
};

export const SINGLE_UNIT_COUNT = 1;

export const SOLE_UNIT_INDEX = 1;

export const CANCEL_TEST_ID = 'logServiceFormCancel';

export const SAVE_TEST_ID = 'logServiceFormSave';

export const TEST_ID = 'logServiceForm';
